export const ENROLLMENT = '/enrollment/'
export const ENROLLMENT_ALL = `${ENROLLMENT}all`
export const ENROLLMENT_STATUS = `${ENROLLMENT}status`
export const ENROLLMENT_STUDENT_OWN = `${ENROLLMENT}student/own`
export const ENROLLMENT_COURSES = `${ENROLLMENT}courses`
